import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

const sliders = []

let slidersHtml = document.querySelectorAll('.slider')

const playVideo = (swiper) => {
  let videoEl = swiper.el.querySelector('.swiper-slide.swiper-slide-active video')
  if (videoEl) {
    videoEl.play()
    return videoEl
  }

  return false
}

const pauseVideos = (swiper) => {
  let videosEl = swiper.el.querySelectorAll('.swiper-slide video')
  if (videosEl.length) {
    videosEl.forEach(videoEl => {
      videoEl.pause()
      videoEl.currentTime = 0
    })
  }
}

if (slidersHtml.length) {
  slidersHtml.forEach(sliderHtml => {
    sliders.push(new Swiper(sliderHtml, {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      watchOverflow: true,
      autoHeight: true,
      on: {
        slideChangeTransitionStart: pauseVideos,
        slideChangeTransitionEnd: swiper => {
          let video = playVideo(swiper)
          if (video) {
            video.muted = false
          }
        },
        init: playVideo
      }
    }))
  })
}



// WEBPACK FOOTER //
// ./scripts/modules/slider.js